export default "__VITE_ASSET__CmWmkMtg__"